const ShareRideDiscount = {
  shareRideDiscount: 'Share Ride Discount',
  addShareRideDiscount: 'Add Share Ride Discount',
  editShareRideDiscount: 'Edit Share Ride Discount',
};
export default ShareRideDiscount;
